export default "__VITE_ASSET__17931b7e__"